import React from "react";
import { Box } from "@mui/material";
import { BULK_MARK_COLORS } from "./bulkMarkColors";

export const ACQUIRED_LABEL = "取得済";
export const REUSABLE_LABEL = "リユース登記あり";

/**
 * 自社取得済みの印はチェックボックス直下の「取得済」の文字。色に頼らず読めるので主情報に向く。
 * リユース候補は副情報として右上の小さな点にし、形と大きさで主従が読めるようにする。凡例の見本も同じ寸法で描く
 */
const MARK_LABEL = {
  fontSize: 10,
  /** チェックボックスの下端から文字までの隙間 */
  gap: 1,
} as const;
export const MARK_DOT = {
  size: 5,
  /** チェックボックス中心からの右上方向のずらし幅（下は「取得済」の文字と重なるため上に置く） */
  offset: 8,
  /** チェック ON の塗りに埋もれないための縁の太さ */
  ring: 1.5,
} as const;
/** 小サイズ（size="small"）の Checkbox アイコンの半径。印はセルではなくチェックボックスを基準に置く */
const CHECKBOX_HALF = 10;

/**
 * 自社取得済みのセルの直下に出す「取得済」（親を配置基準にし、その中心がチェックボックスと一致していること）。
 * 既に手元にある事実の表示なので、注意を引く色は付けず本文色にする
 */
export const AcquiredMark: React.FC = () => (
  <Box
    component="span"
    aria-hidden
    sx={{
      position: "absolute",
      left: "50%",
      top: `calc(50% + ${CHECKBOX_HALF + MARK_LABEL.gap}px)`,
      transform: "translateX(-50%)",
      fontSize: MARK_LABEL.fontSize,
      lineHeight: 1,
      fontWeight: 600,
      whiteSpace: "nowrap",
      color: "text.primary",
      pointerEvents: "none",
    }}
  >
    {ACQUIRED_LABEL}
  </Box>
);

/**
 * リユース候補の点。今の条件では使えない候補（stale=true）なら塗りのない輪だけにする。
 * 縁の色は背景色に追従させ、チェック ON の塗りや行の背景に埋もれないようにする
 */
export const ReusableDot: React.FC<{
  stale?: boolean;
  /** 位置の上書き（凡例の見本用）。省略時はチェックボックス中心基準の右上 */
  sx?: {
    left?: string | number;
    right?: string | number;
    top?: string | number;
  };
}> = ({ stale = false, sx }) => (
  <Box
    component="span"
    aria-hidden
    data-mark="reusable"
    data-reuse-stale={stale ? "" : undefined}
    sx={(theme) => ({
      position: "absolute",
      left: `calc(50% + ${MARK_DOT.offset}px)`,
      top: `calc(50% - ${MARK_DOT.offset + MARK_DOT.size}px)`,
      ...sx,
      width: MARK_DOT.size,
      height: MARK_DOT.size,
      borderRadius: "50%",
      backgroundColor: stale
        ? theme.palette.background.paper
        : BULK_MARK_COLORS.reusableLine,
      boxShadow: stale
        ? `inset 0 0 0 ${MARK_DOT.ring}px ${BULK_MARK_COLORS.reusableLine}, 0 0 0 ${MARK_DOT.ring}px ${theme.palette.background.paper}`
        : `0 0 0 ${MARK_DOT.ring}px ${theme.palette.background.paper}`,
      // チェックボックスの塗りより手前に出す
      zIndex: 1,
      pointerEvents: "none",
    })}
  />
);
